/*eslint-disable*/
import { Link, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    Nav,
    NavItem,
    NavLink,
} from "reactstrap";

import RoadmapIcon from '../../../assets/images/public/p-roadmap-icon.svg';
import RoadmapFilledIcon from '../../../assets/images/public/p-roadmap-filled.svg';
import FeatureIcon from '../../../assets/images/public/p-feature-icon.svg';
import FeatureFilledActive from '../../../assets/images/public/p-feature-active.svg';
import ChangelogIcon from '../../../assets/images/public/p-changelog-icon.svg';
import ChangelogActiveIcon from '../../../assets/images/public/p-changelog-active.svg';

import './roadmap.public.scss';


const PublicTabOption = ({
    changeNavOption,
    navOption,
    changelog_controls,
    publicRoadmapSettings
}) =>{
    const { t } = useTranslation();
   
    return (
    <Nav pills className="publicview-nav">
        <NavItem>
            <NavLink
                onClick={() => changeNavOption('roadmap')}
                active={navOption.parent === 'roadmap'}
            >
                <img src={navOption.parent === 'roadmap' ? RoadmapIcon : RoadmapFilledIcon} className="tab-icon" />
                {t("roadmap")}
            </NavLink>
        </NavItem>
        {
            publicRoadmapSettings?.show_feature_request && (
                <NavItem>
                    <NavLink
                        onClick={() => changeNavOption('feature_requests')}
                        active={navOption.parent === 'feature_requests'}
                    >
                        <img src={navOption.parent === 'feature_requests' ? FeatureFilledActive : FeatureIcon} className="tab-icon" />
                        {t("feature_requests")}
                    </NavLink>
                </NavItem>
            )
        }

        {
            changelog_controls?.show_changelog && (
                <NavItem>
                    <NavLink
                        onClick={() => changeNavOption('changelog')}
                        active={navOption.parent === 'changelog'}
                    >
                        <img src={navOption.parent === 'changelog' ? ChangelogActiveIcon : ChangelogIcon} className="tab-icon" />
                        {t("changelog")}
                    </NavLink>
                </NavItem>
            )
        }
    </Nav>

);
    }

export default PublicTabOption;
